declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, CustomCodeValuesController } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
const isNullOrUndefined = (val: any) => val === null || val === undefined;
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';




@Component({
  selector: 'rxreceipt',
  templateUrl: './rxreceipt.component.html',
  styleUrls: ['./rxreceipt.component.scss']
  , animations: [routerTransition()]
})

export class RxReceiptComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;
  @Input() public FromScreen: string = "NONE";
  @Input() FormattedCode2: string;
  @Input() PatientType2: string;
  @Input() public marginTop: number = 10;
  public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public LChargeEntryCode: number = 0;
  public Tdiscount: number;
  public TotalTax: number;
  // public Tdiscount: number = 0;
  public isRequesting: boolean = false;
  public PrescriberData: PrescribingDoctor[];
  public ReferalData: ReferringDoctor[];
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public paytm: boolean = false;
  public isvisible: boolean = true;
  public FormattedCodedata: any;
  public PatientType: any;
  public GuestName: any;
  public GuestPhone: any;
  public Prescribername: any;
  public Prescribercode: number = 0;
  public Prescriberdesg: any;
  public Referalname: any;
  public ReferalCode: any;
  public Referaldesg: any;
  public TotalBill: number;
  public NetPayable: number;
  public BranchName: string;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  public ChargeEntryCodeModal: number = 0;
  searchTitle: string;
  // public SelectedPrescriber: PrescribingDoctor[];
  //public SelectedReferral: ReferringDoctor[];
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          this.LoadDoctorsList();
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {    
    this.StoreCode = AppData.Instance().cas.RxDefault_StoreCode;
    //alert(this.StoreCode);
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.Tdiscount = 0;
    this.TotalTax = 0;
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
    //if (this.FromScreen == 'NONE') {
    //  this.PatientType = this.route.snapshot.paramMap.get('PatientType');
    //}
    //else if (this.FromScreen == 'CommonBilling') {
    //  this.PatientType = this.PatientType2;
    //}
    //this.PatientType = this.route.snapshot.paramMap.get('PatientType');
    this.GuestName = this.route.snapshot.paramMap.get('GuestName');
    this.GuestPhone = this.route.snapshot.paramMap.get('GuestPhone');
    if (this.FromScreen == 'NONE') {
      this.PatientType = this.route.snapshot.paramMap.get('PatientType');
      this.LoadPatients(this.FormattedCodedata);
    }
    else if (this.FromScreen == 'CommonBilling') {
      this.PatientType = this.PatientType2;
      this.LoadPatients(this.FormattedCode2);
    }
    //this.LoadPatients(this.FormattedCodedata);
    //this.LoadServicesByCategory();
    //this.LoadDoctorPres();
    //this.LoadDoctorRef();
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.StoreCode = parseInt(
    //  AppData.Instance().GetDataParam("RxDefaultStore"));
    //if (this.StoreCode != 0)
  // this.StoreItems();
    //alert(this.PatientType);
  }

  CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory() {

    this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
    this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
    this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode = this.Prescribercode;
    this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    this.pdata = this.CurrentServicesByCategoryCodeController;
    this.GetServicesByCategoryCodeController();

  }
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
          this.pdata = this.CurrentServicesByCategoryCodeController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    // this.pdata = this.CurrentDoctorsListController;
    //this.pdata1 = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;

          var prxcode = AppData.Instance().cas.Prescribing_DoctorCode;

          var y = this.CurrentDoctorsListController
            ? this.CurrentDoctorsListController.filter(X => X.ProviderCode == prxcode)[0]
            : null;

          if (y) {
            this.Prescribercode = y.ProviderCode;
            this.Prescriberdesg = y.Specialty;
          } else {
            this.Prescribercode = prxcode || 0;
            this.Prescriberdesg = '';
          }
          this.Prescribername = AppData.Instance().cas.Prescribing_DoctorName;

            this.LoadDoctorPres();
          
          if (this.SelectedPatientFormattedCode.RefDetails != 'null') {
            this.CurrentReferringDoctor = null;
            this.ReferalCode = this.SelectedPatientFormattedCode.RefCode;
            var x = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.RefDetails);
            if (x.length == 0 || isNullOrUndefined( x[0].Specialty))
              this.Referaldesg = "";
            else
              this.Referaldesg =x[0].Specialty;
            this.Referalname = this.SelectedPatientFormattedCode.RefDetails;
            this.LoadDoctorRef();
          }
          if (this.SelectedPatientFormattedCode.RefDetails == 'null') {
            // this.CurrentReferringDoctor = null;
            this.ReferalCode = 0;
            this.Referaldesg = "null";
            this.Referalname = "null";
            this.LoadDoctorRef();
          }

          //this.pdata = this.CurrentDoctorsListController;
          //this.pdata1 = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentX_BillHeaderController: X_BillHeaderController;
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    this.CurrentX_BillHeaderRequest.ChargeEntry = this.LChargeEntryCode;
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  selectedGroupnew: PrescribingDoctor;
  onChange(Event: any) {
    //alert(Event.value);
    if (Event != null) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      //alert(a.length);
      if (a.length > 0) {
        this.CurrentPrescribingDoctor = null;
        this.CurrentReferringDoctor = null;
        this.Prescribername = a[0].DisplayName;
        this.Prescribercode = a[0].ProviderCode;
        this.Prescriberdesg = a[0].Specialty;
        this.LoadDoctorPres();
        this.LoadDoctorRef();
        //this.LoadServicesByCategory(this.Prescribercode);
        //alert(this.Prescribername);

        //        // alert(this.ActivityDate);
      }
    }
  }
  CurrentPrescribingDoctor: Array<PrescribingDoctor>;
  LoadDoctorPres() {
    if (this.CurrentPrescribingDoctor == null) {
      this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
    }
    if (this.CurrentPrescribingDoctor != null) {
      var row = new PrescribingDoctor();
      row.DoctorName = this.Prescribername;
      row.DoctorCode = this.Prescribercode;
      row.Designation = this.Prescriberdesg;
      this.CurrentPrescribingDoctor.push(row);
    }
  }

  CurrentReferringDoctor: Array<ReferringDoctor>;

  LoadDoctorRef() {
    if (this.CurrentReferringDoctor == null) {
      this.CurrentReferringDoctor = new Array<ReferringDoctor>();
    }
    if (this.CurrentReferringDoctor != null) {
      var row = new ReferringDoctor();
      row.DoctorName = this.Referalname;
      row.DoctorCode = this.ReferalCode;
      row.Designation = this.Referaldesg;
      this.CurrentReferringDoctor.push(row);
    }
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  cashdata() {
    this.cash = true;
  }
  carddata() {
    this.card = true;
  }
  chequedata() {
    this.cheque = true;
  }
  demanddraftdata() {
    this.demanddraft = true;
  }
  paytmdata() {
    this.paytm = true;
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentStoreLocationMaterialsController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentStoreLocationMaterialsController,
          this.listFilter);
      }
    }
  }

  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //docedit() {

  //    const modalRef = this.modalService.open(NgbAddBill,
  //        {
  //            centered: true,
  //            size: "lg",
  //            backdrop: 'static',
  //            keyboard: false
  //        })
  //    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
  //    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //        this.SelectedPrescriber = receivedEntry.make;
  //        this.SelectedReferral = receivedEntry.value;

  //       alert(this.ProvidedName);
  //    })


  //}
  CancelNewOperation() {

    this.ShowList = true;
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  AddRow2(l: StoreLocationMaterialsController) {
    const modalRef = this.modalService.open(NgbBatchDetail2Modal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.ConsumptionGroup = "";
    modalRef.componentInstance.StroreLocation = this.StoreName;
    modalRef.componentInstance.MaterialName = l.Description;
    modalRef.componentInstance.ItemCode = l.MaterialSpec;
    modalRef.componentInstance.StoreCode = this.StoreCode;

    modalRef.componentInstance.GroupName = l.GroupName;
    modalRef.componentInstance.GroupCode = l.MaterialGroup;
    modalRef.componentInstance.SaleUOM = l.SaleUOM;

    modalRef.componentInstance.BatchCode = 0;
    modalRef.componentInstance.BatchName = "";
    modalRef.componentInstance.Quantity = 1;
    modalRef.result.then((val: MaterialBatchInaStoreController) => {
      this.AddRow(val);
      //alert(this.AddRow);

    });

  }
  //StoreChanged() {
  //    this.StoreCode = AppData.Instance.SelectedStore.SelectedStoreCode;
  //    this.StoreName = AppData.Instance.SelectedStore.SelectedStoreName;
  //    this.StoreItems();
  //}
  CurrentBillDetails: Array<BillDetails>;
  AddRow(l: MaterialBatchInaStoreController) {
    if (this.CurrentBillDetails == null) {
      this.CurrentBillDetails = new Array<BillDetails>();
    }
    var itemExists = this.CurrentBillDetails.find(x => x.BatchNumber == l.BatchNo);
    if (itemExists != null) {
      return;
    }
    //var ite = this.deletedBillDetails.find(x => x.ServiceDescription == l.MaterialSpecName);
    //if (ite != null) {
    ////  this.CurrentBillDetails.push(item);
    //  this.deletedBillDetails.splice(this.deletedBillDetails.findIndex(x => x.ServiceDescription == l.MaterialSpecName), 1);
    //}
    var item = this.deletedBillDetails.find(x => x.ServiceDescription == l.MaterialSpecName);
    if (item != null) {
      this.CurrentBillDetails.push(item);
      this.deletedBillDetails.splice(this.deletedBillDetails.findIndex(x => x.ServiceDescription == l.MaterialSpecName), 1);
    }
    else {
      var row = new BillDetails();
      row.Edit = false;
      row.RowNumber = row.RowNumber + 1;
      row.ServiceDescription = l.MaterialSpecName;
      row.Quantity = l.Quantity;
      row.Discount = 0;
      row.UnitPrice = l.SellingPrice;
      row.ItemCode = l.MaterialSpecCode;
      row.ItemRate = l.SellingPrice * row.Quantity;
      row.GroupName = "";
      row.PackageName = "";
      row.DiscountAllowed = true;
      row.ChargeItemCode = 0;
      row.ExpiryDate = l.ExpiryDate;
      row.BatchNumber = l.BatchNo;
      row.SupplierMaterialBatchCode = l.MaterialBatchStorage;
      row.SupplierBatchDetails = l.BatchNo;
      row.TaxPercentage = l.TaxPercent;
      this.CurrentBillDetails.push(row);
      }

 //   alert(this.CurrentBillDetails.length);

    this.TotalBill = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current));

  //  alert(this.TotalBill);

    this.NetPayable = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current) - this.Tdiscount);


  //  alert(this.NetPayable);

    var hastaxes = this.CurrentBillDetails.filter((item) => item.TaxPercentage > 0);
    if (hastaxes.length > 0) {
      this.TotalTax = this.CurrentBillDetails.filter((item) => item.TaxPercentage > 0)
        .map((item) => +  this.getTax(item))
        .reduce((sum, current) => sum + current);

     // alert(this.TotalTax);
    }
    else
      this.TotalTax = 0;

    this.BranchName = AppData.Instance().SelectedBranchName;
    this.Date = new Date();
    //        alert(l.BasePrice);

    this.AddData();

  }
  // TotalTax: number;
  getDisc(item: BillDetails): number {
    if (item.Discount > 0)
      return (item.ItemRate * item.Discount) / 100;
    return 0;
  }
  getTax(item: BillDetails): number {
    if (item.TaxPercentage > 0)
      return (item.ItemRate - this.getDisc(item)) - ((((item.ItemRate - this.getDisc(item)) * 100) / (100 + item.TaxPercentage)));

    return 0;
  }


  CurrentNewBillData: NewBillData;
  AddData() {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;


    this.CurrentNewBillData.BillDate = new Date();
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "RX";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    this.CurrentNewBillData.Items = this.CurrentBillDetails;
    this.CurrentNewBillData.DeletedItems = this.deletedBillDetails;
    this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
    this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
    if (this.PatientType == 'Registered') {
      this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
      this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
      this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    }
    if (this.PatientType == 'Guest') {
      this.CurrentNewBillData.PatientFormattedCode = this.FormattedCodedata;
      this.CurrentNewBillData.PatientName = this.GuestName;
      this.CurrentNewBillData.PhoneNumber = this.GuestPhone;
    }

    this.CurrentNewBillData.TotalDiscount = this.Tdiscount;

    //eranki
    this.CurrentNewBillData.TotalTax = this.CurrentBillDetails.filter((item) => item.TaxPercentage >= 0)
      .map((item) => +  this.getTax(item))
      .reduce((sum, current) => sum + current, 0);


    this.CurrentNewBillData.TotalBill = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current));
    this.CurrentNewBillData.NetPayable = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current) - this.Tdiscount);

    //this.CurrentNewBillData.NetPayable = Math.round(this.CurrentNewBillData.NetPayable);// + Math.
    //this.CurrentNewBillData
    this.SaveData();


  }
  SaveData() {
    this.spinner.show();
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.LChargeEntryCode.toString();
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          //if (!this.ApiResData.hasError) {

          //   if (this.ApiResData.Result > 0) {
          this.LChargeEntryCode = this.ApiResData.Result[0].Result;
          // alert(this.LChargeEntryCode);
          //this.GetActorEducationInfoController();
          //this.GetResourceIdentificationByDateInfoController();
          // alertFunctions.AlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          // this.Listview = true;
          //this.EditEmbryo = false;
          //this.LoadStoreData();
          //this.AddEmbryo = false;
          //this.spinner.hide();
          //this.activeModal.close();
          //this.clearData();
          // this.LoadScansData();
          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");

          //this.spinner.hide();
          this.stopRefreshing();
          this.spinner.hide();
        }

      },





        (error) => {
          // alert("kkhkhjkhkjhjkh");

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  public istextshow: boolean = false;
  Qunatitychange(l: BillDetails) {

    if (l.Quantity < 1) {
      this.isvisible = false;
      this.istextshow = true;
    }
    else if (l.Quantity == 1 || l.Quantity > 1) {
      this.isvisible = true;
      this.istextshow = false;
    }
    l.ItemRate = l.Quantity * l.UnitPrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current, 0);
    l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
    this.Tdiscount = Math.round(this.CurrentBillDetails.filter(l => l.rDiscount)
      .reduce((sum, current) => sum + current.rDiscount, 0));
    this.NetPayable = Math.round(this.TotalBill - this.Tdiscount);

    //eranki
    this.TotalTax = this.CurrentBillDetails.filter((item) => item.TaxPercentage >= 0)
      .map((item) => +  this.getTax(item))
      .reduce((sum, current) => sum + current);
  }
  Discountchange(l: BillDetails) {
    if (l.Discount < 0) {
      this.isvisible = false;
    }
    else if (l.Discount > 100) {
      this.isvisible = false;
    }
    else if (l.Discount == 0 || l.Discount < 100) {
      this.isvisible = true;
    }

    l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    this.Tdiscount = Math.round(this.CurrentBillDetails.filter(l => l.rDiscount)
      .reduce((sum, current) => sum + current.rDiscount, 0));
    this.NetPayable = Math.round(this.TotalBill - this.Tdiscount);

    //eranki
    this.TotalTax = this.CurrentBillDetails.filter((item) => item.TaxPercentage >= 0)
      .map((item) => +  this.getTax(item))
      .reduce((sum, current) => sum + current);
  }

  //alert(this.CurrentBillDetails.length);
  // CurrentBillDetailsEdit: BillDetails;
  Editrow(l: BillDetails) {
    //this.Add = false;

    //this.Edit = true;
    l.Edit = true;
    //this.CurrentBillDetailsEdit = new BillDetails();
    //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
    //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
    //this.CurrentBillDetailsEdit.quantity = l.quantity;
    //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
    //this.CurrentBillDetailsEdit.discount = l.discount;
    //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

  }
  deletedBillDetails: Array<BillDetails> = new Array<BillDetails>();
  delete(i: number, l: BillDetails) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.deleterow(i, l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }

  deleterow(i: number, l: BillDetails) {
    this.CurrentBillDetails.splice(i, 1);
    this.TotalBill = this.CurrentBillDetails.filter(item => item.ItemRate)
      .reduce((sum, current) => sum + current.ItemRate, 0);
    this.Tdiscount = this.CurrentBillDetails.filter(item => item.rDiscount)
      .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = Math.round(this.TotalBill - this.Tdiscount);
    //eranki
    this.TotalTax = this.CurrentBillDetails.filter((item) => item.TaxPercentage >= 0)
      .map((item) => +  this.getTax(item))
      .reduce((sum, current) => sum + current, 0);
    //this.Discountchange(l);
    if (this.LChargeEntryCode > 0) {
      if (this.deletedBillDetails != null) {
        var row = new BillDetails();
        row.Edit = false;
        row.RowNumber = row.RowNumber + 1;
        row.ServiceDescription = l.ServiceDescription;
        row.Quantity = l.Quantity;
        row.Discount = l.Discount;
        row.ItemCode = l.ItemCode;
        row.UnitPrice = l.UnitPrice;
        row.ItemRate = l.UnitPrice * l.Quantity;
        row.GroupName = l.GroupName;
        row.PackageName = l.PackageName;
        row.DiscountAllowed = l.DiscountAllowed;
        row.ChargeItemCode = 0;
        row.ExpiryDate = l.ExpiryDate;
        row.BatchNumber = l.BatchNumber;
        row.SupplierMaterialBatchCode = l.SupplierMaterialBatchCode;
        row.SupplierBatchDetails = l.BatchNumber;
        row.TaxPercentage = l.TaxPercentage;
        this.deletedBillDetails.push(row);
      }

    }
  }
  OnClear(l: BillDetails) {
    l.Edit = false;
  }
  Payment() {
    this.AddData();
    const modalRef = this.modalService.open(NgbPaymentModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    if (this.PatientType == 'Registered') {
      modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
      modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
      modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
      modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
      modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
      modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    }
    if (this.PatientType == 'Guest') {
      modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
      modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
      modalRef.componentInstance.PatientName = this.GuestName;
      modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
      modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
      modalRef.componentInstance.Telephone1 = this.GuestPhone;
    }
    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    //modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
    //modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
    modalRef.componentInstance.TotalBill = Math.round(this.CurrentNewBillData.TotalBill);
    modalRef.componentInstance.NetPayable = Math.round( this.CurrentNewBillData.NetPayable);
    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    modalRef.componentInstance.ChargeEntryCode = this.LChargeEntryCode;
    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    modalRef.componentInstance.BillType2 = "RX";
    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;
    modalRef.componentInstance.PatientCode = this.CurrentPatientInfoByFormattedCodeController[0].PatientRegistrationNumber;
    modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
    modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;
    modalRef.result.then((val: number) => {
      this.ChargeEntryCodeModal = val;
      this.LoadBillHeader();
    });

  }
  Cancel() {
    this.router.navigate(['healins/pharmacybill']);
  }
  Cancel2() {
    this.router.navigate(['healins/combinedbilling']);
  }
  opbill() {

  }
  docedit() {
    //this.PrimaryDoctorO = false;
    //this.PrimaryDoctorn = true;

    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.IsShowDoctor = true;
    modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.Prescribername = receivedEntry.make;
      this.Prescribercode = receivedEntry.value;
      this.Prescriberdesg = receivedEntry.desg;
      this.CurrentPrescribingDoctor = null;
      this.LoadDoctorPres();

      // this.Refcode = this.SelectedPatientFormattedCode.RefCode;
      //this.Refdesg = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.RefDetails)[0].Specialty;
      //this.Refname = this.SelectedPatientFormattedCode.RefDetails;
      //this.LoadDoctorRef();

      //this.PrimaryNumber = receivedEntry.number;
      // this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
      //alert(this.ProviderName);
    })
  }
  StoreCode: number = 0;
  public StoreName: string;
  onAssignedToActorCodesurgeon2(event: any) {

    if (event != null) {
      this.StoreName = event;
     this.StoreItems();
      /// this.GroupItems();
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
      // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  accessibleStores : CustomCodeValuesController[];
  loaded_data(e: any) {
    this.accessibleStores = e as CustomCodeValuesController[];
    var x = this.accessibleStores.find(x => x.Code == this.StoreCode);
    if (!isNullOrUndefined(x)) {
      this.StoreItems();
    }
  //  alert(this.accessibleStores.length);

  }
  StoreList_loaded(e: any) {

    //alert(e);
    //this.StoreItems();

  }
  CurrentStoreLocationMaterialsRequest: StoreLocationMaterialsRequest;
  CurrentStoreLocationMaterialsController: StoreLocationMaterialsController[];
  StoreItems() {    
    // alert()
    this.CurrentStoreLocationMaterialsRequest = new StoreLocationMaterialsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentStoreLocationMaterialsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentStoreLocationMaterialsRequest.ConditionalOperator = 10;
    this.CurrentStoreLocationMaterialsRequest.StoreCode = this.StoreCode;
    this.pdata = this.CurrentStoreLocationMaterialsController;

    this.GetStoreLocationMaterialsController();

  }
  GetStoreLocationMaterialsController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetStoreLocationMaterialsController(this.CurrentStoreLocationMaterialsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentStoreLocationMaterialsController = this.ApiResData.Result;
          this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  rxbill() {
    this.printService.printDocument4('0', this.LChargeEntryCode

    );
    this.printService.printDocument3(this.CurrentX_BillHeaderController.BillNo, 0

    );
    this.printService.printDocument("pharmacybill",
      {
        ChargeEntryData: this.LChargeEntryCode,
        PatientId: this.SelectedPatientFormattedCode.FormattedCode,
        Owner: this.SelectedPatientFormattedCode.DisplayName,
        Gender: this.SelectedPatientFormattedCode.Gender,
        Age: this.SelectedPatientFormattedCode.Age,
        BillDate: this.CurrentNewBillData.BillDate,
        BillNo: this.CurrentX_BillHeaderController.BillNo,
        Branch: this.CurrentNewBillData.BranchName,
        ReceiptFormattedCode: this.CurrentX_BillHeaderController.ReceiptFormattedCode,
        GrandTotal: this.CurrentNewBillData.TotalBill,
        Discount: this.CurrentNewBillData.TotalDiscount,
        Tax: this.CurrentX_BillHeaderController.Tax,
        Net: Math.round(this.CurrentNewBillData.NetPayable),
        Due: this.CurrentX_BillHeaderController.Balance,
        ReferralData: this.CurrentNewBillData.ReferringDoctor,

      },

    );
  }
}
//export class BillDetails {
//  public ItemCode: number;
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;
//  public rDiscount: number;
//  public ExpiryDate: Date;
//  public BatchNumber: string;
//  public SupplierBatchDetails: string;
//  public SupplierMaterialBatchCode: number;
//  public EditableCharge: boolean;
//  public RefundableAmount: number;
//  public RefundableQuantity: number;
//  public TaxPercentage: number;
//}
//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}

